import React from 'react';
import { useAppSelector } from "src/store/hooks";

import { Spin } from "antd";
import Pagination from 'src/componets/Pagination';
import Edit from "../Edit";
import ListGrid from "./_ListGrid";
import ListTable from "./_ListTable";

import '../style.scss';

interface propsInterface {
  limit: number;
  pagination: boolean;
  type?: 'list' | 'grid';
}

const _List = ({ limit, pagination, type = 'grid' }: propsInterface) => {
  const count  = useAppSelector(state => state.community.posts.count);
  const error  = useAppSelector(state => state.community.posts.error);
  const status = useAppSelector(state => state.community.posts.status);

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  return (
    <>
      { type === 'grid' && <ListGrid /> }
      { type === 'list' && <ListTable className='v-mb-15' /> }

      {pagination && <Pagination total={count} size={limit} />}

      <Edit />
    </>
  );
}

export default _List;
